<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_4">Acknowledgement</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Many thanks to:</p>
<p class="block_2">Angeline, you said, “Your father was right, you are good.”</p>
<p class="block_2">Sun, you said, “Mom, you have to do it.”</p>
<p class="block_2">Abigail, you said, “If you can’t, God can.”</p>
<p class="block_2">Kiki, my editor, thanks for the corrections.</p>
<p class="block_2">Leo, thanks for getting me to protect my work.</p>
<p class="block_2">Farai, you are worth a hundred elephants.</p>
<p class="block_2">Thank you all for your encouragement and support.</p>
<p class="block_2">Austin Macauley Publishers, you are the dream.</p>
<p class="block_3" id="calibre_pb_3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?4934cd0f